import { Schema } from "@markdoc/markdoc";

export const value: Schema = {
  selfClosing: true,
  render: "CopyableInlineCode",
  attributes: {
    value: {
      type: String,
      required: true,
    },
    copyLabel: {
      type: String,
      default: "Copy",
    },
  },
};
